import { PROFILE_MEDIA_LIMIT } from '../components/ProfileMediaSection';
import { api, ApiError } from '../services/api';

// 9.18.10.4 · D-830 — what the importer must know about one's own profile:
// which archive paths are already there and how many places are left. It
// asks the light keys route; an older API without it (404) is answered from
// the first page of the list instead.

export type OwnMediaKeys = { keys: ReadonlySet<string>; slotsLeft: number };

export async function loadOwnMediaKeys(token: string): Promise<OwnMediaKeys> {
  try {
    const { keys, count, limit } = await api.getMyProfileMediaKeys(token);
    return { keys: new Set(keys), slotsLeft: Math.max(0, limit - count) };
  } catch (error) {
    if (!(error instanceof ApiError) || error.status !== 404) throw error;
    const page = await api.getMyProfileMedia(token);
    const keys = page.items.map((item) => item.source_key).filter((key): key is string => typeof key === 'string');
    const count = typeof page.total === 'number' ? page.total : page.items.length;
    return { keys: new Set(keys), slotsLeft: Math.max(0, (page.limit ?? PROFILE_MEDIA_LIMIT) - count) };
  }
}
